import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-puzzle-background">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-puzzle-muted">404</h1>
        <h2 className="text-2xl font-semibold text-puzzle-text mt-4">
          Page Not Found
        </h2>
        <p className="text-puzzle-text-secondary mt-2 mb-8">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-block bg-puzzle-blue text-white px-6 py-3 rounded-lg font-medium hover:opacity-90 transition-colors"
        >
          Go Back Home
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
